// src/slices/index.js

import { combineReducers } from 'redux';

import confirmationParamReducer from './confirmationParam';
import masterTaskListReducer from './masterTaskList';
import selectedCloneDtlReducer from './selectedCloneDtl';
import clinicalInvestigatorLovReducer from './clinicalInvestigatorLov';
import dashboardSiteLovReducer from './dashboardSiteLovSlice';
import headerSummaryReducer from './headerSummarySlice';
import siteBrowserLovReducer from './siteBrowserLov';
import taskViewToggleReducer from './taskViewToggleSlice';
import toasterMessageReducer from './toasterMessage';
import dashboardFilterReducer from './dashboardFilterSlice';

const rootReducer = combineReducers({
  masterTaskList: masterTaskListReducer,
  toasterMessage: toasterMessageReducer,
  siteBrowserLov: siteBrowserLovReducer,
  confirmationParam: confirmationParamReducer,
  selectedCloneDtl: selectedCloneDtlReducer,
  headerSummary: headerSummaryReducer,
  taskView: taskViewToggleReducer,
  clinicalInvestigatorLov: clinicalInvestigatorLovReducer,
  dashboardSiteLov: dashboardSiteLovReducer,
  dashboardFilter: dashboardFilterReducer
});

export default rootReducer;
